jQuery(function($) {

  const $casel_sites_links = $('#casel-sites a, #casel-sites button');

  const $first_casel_sites_link = $('#casel-sites button').first();
  const $last_casel_sites_link = $('#casel-sites a').last();

  $last_casel_sites_link.on('keydown', function(e) {
    if (!e.shiftKey) {
      e.preventDefault();
      $first_casel_sites_link.focus();
    }
  });

  $first_casel_sites_link.on('keydown', function(e) {
    if (e.shiftKey) {
      e.preventDefault();
      $last_casel_sites_link.focus();
    }
  });

  // Remove CASEL links from tab index
  if ($casel_sites_links !== undefined) {
    $casel_sites_links.attr('tabindex', '-1');
  }

  // Manage Opening sites nav
  const $open_sites = $('.toggle-sites');
  $open_sites.click(function() {
    $('.casel-sites').addClass('open');
    $casel_sites_links.attr('tabindex', '');
    $('#js-close-sites').focus();
  });

  // Manage closing sites nav
  const $close_sites = $('#js-close-sites');
  $close_sites.click(function() {
    $casel_sites_links.attr('tabindex', '-1');
    $('.casel-sites').removeClass('open');
  });

  // Manage dropdowns
  const $child_nav_toggles = $('.js-toggle-child-list');

  $(window).click(function(e) {
    if (e.target.id !== 'js-toggle-sites' && e.target.id !== 'js-toggle-sites-mobile') {
      if (!e.target.id === 'casel-sites' || !$(e.target).parents('#casel-sites').length) {
        $('.casel-sites').removeClass('open');
      }
    }

    if (!$(e.target).parents('#primary-nav-list').length) {
      $child_nav_toggles.removeClass('open');
      $child_nav_toggles.next('ul').hide();
    }
  });


  $child_nav_toggles.click(function() {
    $child_nav_toggles.not($(this)).next('ul').hide();
    $child_nav_toggles.not($(this)).removeClass('open');
    $(this).toggleClass('open');
    $(this).next('ul').toggle();
  });

  $child_nav_toggles.focus(function() {
    if ($(window).width() > 1024) {
      $child_nav_toggles.removeClass('open');
      $child_nav_toggles.not($(this)).next('ul').hide();
    }
  });

  $child_nav_toggles.on('keydown', function(e) {
    if ($(window).width() > 1024) {
      $(this).addClass('open');
      $(this).next('ul').show();

      if (e.keyCode === 40) {
        e.preventDefault();
        $(this).next('ul').find('li:first-child a').focus();
      }

      if (e.keyCode === 27) { // tab or esc
        $(this).blur();
        $(this).removeClass('open');
        $(this).next('ul').hide();
      }
    }
  });

  $('.primary-nav-list a').keydown(function(e) {
    if (e.keyCode === 40) { // down or right
      e.preventDefault();
      $(this).parent().next('li').find('a').focus();
    }
    if (e.keyCode === 38) { // up or left
      e.preventDefault();
      $(this).parent().prev('li').find('a').focus();
    }
    if (e.keyCode === 9 || e.keyCode === 27) { // tab or esc
      $(this).parent('li').parent('ul').hide();
      $(this).blur();
    }
  });
});
